'use client';

import { useContext } from 'react';
import { CartContext } from '../providers/CartContext';
export const useCart = () => {
  const context = useContext(CartContext);
  if (context === undefined || context === null) {
    throw new Error("useCart must be used within a CartContext");
  }
  return context;
};